export const PAYMENT_ACTIVATION = 'PAYMENT_ACTIVATION';
export const SAVE_BUSINESS_DETAILS_REQUEST = `${PAYMENT_ACTIVATION}/saveBusinessDetailsRequest`;
export const SAVE_STAKEHOLDER_DETAILS_REQUEST = `${PAYMENT_ACTIVATION}/saveStakeholderDetailsRequest`;
export const SAVE_BANK_DETAILS_REQUEST = `${PAYMENT_ACTIVATION}/saveBankDetailsRequest`;
